var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFocus = function SvgFocus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 790 790"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: "M300.673 82.293c-87.765 2-139.028 10.354-174.053 45.258-30.654 30.548-40.902 73.491-44.327 142.367M489.331 82.293c87.765 2 139.026 10.354 174.053 45.258 30.652 30.548 40.899 73.491 44.326 142.367M489.331 707.71c87.765-2.002 139.026-10.356 174.053-45.257 30.652-30.55 40.899-73.494 44.326-142.368M300.673 707.71c-87.765-2.002-139.028-10.356-174.053-45.257-30.654-30.55-40.902-73.494-44.327-142.368"
  })));
};
export default SvgFocus;